import React, { useState, useEffect } from 'react';
import { Popup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { LoadPanel } from 'devextreme-react/load-panel';
import DataGrid, { Column, Selection, Scrolling, Paging } from 'devextreme-react/data-grid';
import axios from 'axios';
import notify from 'devextreme/ui/notify';

const TransactionSignatures = ({ visible, onClose, transactionHeaderRowId, transactionNumber, accessToken, onRecapture }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [signatures, setSignatures] = useState([]);
    const [selectedSignatureUrl, setSelectedSignatureUrl] = useState(null);

    useEffect(() => {
        if (visible && transactionHeaderRowId) {
            fetchSignatures();
        }
        if (!visible) {
            setSignatures([]);
            setSelectedSignatureUrl(null);
        }
    }, [visible, transactionHeaderRowId]);

    const fetchSignatures = async () => {
        setIsLoading(true);
        try {
            const apiUrl = `${window._env_.REACT_APP_APIS}/wm/TransactionHeaderOperations/GetTransactionSignatures`;
            const response = await axios.get(apiUrl, {
                params: { transactionHeaderRowId },
                headers: {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                }
            });

            if (response.data && Array.isArray(response.data)) {
                setSignatures(response.data);
                if (response.data.length > 0) {
                    setSelectedSignatureUrl(response.data[0].signatureImage);
                }
            } else if (response.data?.data && Array.isArray(response.data.data)) {
                setSignatures(response.data.data);
                if (response.data.data.length > 0) {
                    setSelectedSignatureUrl(response.data.data[0].signatureImage);
                }
            }
        } catch (error) {
            console.error('Error fetching signatures:', error);
            notify({
                message: error.response?.data?.message || 'Error retrieving signatures.',
                width: 300,
            }, 'error', 3000);
        } finally {
            setIsLoading(false);
        }
    };

    const onRowClick = (e) => {
        if (e.data?.signatureImage) {
            setSelectedSignatureUrl(e.data.signatureImage);
        } else {
            setSelectedSignatureUrl(null);
        }
    };

    return (
        <Popup
            visible={visible}
            onHiding={onClose}
            dragEnabled={true}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={`Show Transaction Signatures (${transactionNumber || ''})`}
            width={700}
            height={550}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative' }}>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    visible={isLoading}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    hideOnOutsideClick={false}
                />
                <div style={{ flex: '0 0 auto', maxHeight: '180px' }}>
                    <DataGrid
                        dataSource={signatures}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        columnAutoWidth={true}
                        height="180px"
                        onRowClick={onRowClick}
                        hoverStateEnabled={true}
                    >
                        <Selection mode="single" />
                        <Scrolling mode="virtual" />
                        <Paging enabled={false} />
                        <Column dataField="status" caption="Status" />
                        <Column dataField="creationDateTime" caption="Creation Date Time" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                        <Column dataField="type" caption="Type"   />
                        <Column dataField="name" caption="Name" />
                        <Column dataField="reference" caption="Reference" />
                    </DataGrid>
                </div>
                <div style={{
                    flex: 1,
                    border: '1px solid #ccc',
                    backgroundColor: '#fff',
                    margin: '10px 0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    minHeight: '200px'
                }}>
                    {selectedSignatureUrl ? (
                        <img
                            src={selectedSignatureUrl}
                            alt="Signature"
                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                        />
                    ) : (
                        <span style={{ color: '#999', fontSize: '14px' }}>(imgSignature)</span>
                    )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <Button text="Recapture" type="normal" icon="refresh" onClick={() => { if (onRecapture) onRecapture(); }} />
                </div>
            </div>
        </Popup>
    );
};

export default TransactionSignatures;
